import { useAuth } from '@beukay/auth-mall';
import { getMatchMenu } from '@umijs/route-utils';
import type { Route } from '@umijs/route-utils/dist/types';
import { Breadcrumb } from 'antd';
import type { ItemType } from 'antd/es/menu/hooks/useItems';
import { get } from 'es-cookie';
import { createContext, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, history, matchRoutes, useLocation } from 'umi';
import { Footer, Header, SEO, SiderMenu } from '@/components';
import { useAuthLogin, useFormatMessage } from '@/hooks';
import routes from '../../config/routes';

export function urlToList(url?: string): string[] {
  if (!url || url === '/') {
    return [];
  }
  const urlList = url.split('/').filter((i) => i);
  return urlList.map((_, index) => `/${urlList.slice(0, index + 1).join('/')}`);
}

interface LayoutContextPorps {
  menus: ItemType[];
  selectedKeys: string[];
  openKeys: string[];
  setOpenKeys: (val: string[]) => void;
}

export const LayoutContext = createContext<LayoutContextPorps>({
  menus: [],
  selectedKeys: [],
  openKeys: [],
  setOpenKeys: () => {},
});
const Index = () => {
  const { user } = useAuth();
  const { onAuthLogin } = useAuthLogin();
  const { formatMessage } = useFormatMessage();
  // const [title, setTitle] = useState<string>('');
  const [menus, setMenus] = useState<ItemType[]>([]);
  console.log('menus', menus);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const location = useLocation();

  // @ts-ignore
  const getSubMenuOrItem = (item: Route) => {
    const children = item?.routes;
    if (item?.hideInMenu) {
      return null;
    }
    if (Array.isArray(children) && children.length > 0) {
      const name = item.name;

      return {
        label: formatMessage({ id: name as any }),
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        children: getNavMenuItems(children),
        key: item.key || item.path,
      };
    }
    return {
      label: formatMessage({ id: item.name as any }),
      key: item.key || item.path,
      onClick: () => history.push(item.path || ''),
    };
  };

  // @ts-ignore
  const getNavMenuItems = (routes: Route[]) =>
    routes.map((route) => getSubMenuOrItem(route)).filter((item) => item);

  const initItems = () => {
    const manage = routes.filter((item) => item.path === '/manage')[0];
    if (manage && manage?.routes) {
      const ls = getNavMenuItems(manage?.routes);
      setMenus(ls);
    }
  };

  useEffect(() => {
    initItems();
  }, []);

  useEffect(() => {
    const token = get('token');
    if (!user?.userId || !token) {
      onAuthLogin();
    }
  }, [location.pathname]);

  const selectedKeys = useMemo(() => {
    if (menus?.length > 0) {
      // @ts-ignore
      const ls = getMatchMenu(location.pathname || '/', menus || [], true);
      if (ls?.length > 0) {
        const key = ls[ls.length - 1]?.key as string;
        return [key];
      }
    }
    return [];
  }, [location.pathname, menus]);

  useEffect(() => {
    if (menus?.length > 0) {
      const ls = menus.map((item) => item?.key) as string[];
      setOpenKeys(ls);
    }
  }, [menus]);

  const props = {
    selectedKeys,
    openKeys,
    setOpenKeys,
    menus,
  };

  const { breadcrumbItems, title } = useMemo(() => {
    let _routes = routes;
    let title: string = '';
    const paths = urlToList(location.pathname);
    const length = paths.length;
    if (!length) return {};
    const breadcrumbItems = paths.map((path, index) => {
      const match = matchRoutes(_routes || [], path);
      if (match?.length) {
        const route: Record<string, any> = match[0]?.route || {};
        _routes = route?.routes;
        // if(!route?.component) return null;
        const isLink = index !== length - 1;
        title = formatMessage({ id: route.name as any });
        return (
          <Breadcrumb.Item key={path}>
            {isLink ? (
              <Link to={path}>{title}</Link>
            ) : (
              <span className="text-cc3">{title}</span>
            )}
          </Breadcrumb.Item>
        );
      }
      return null;
    });
    breadcrumbItems.shift();
    breadcrumbItems.unshift(
      <Breadcrumb.Item key="/">
        <Link to="/">
          {formatMessage({ id: 'pages.userCenter.breadcrumb.home' })}
        </Link>
      </Breadcrumb.Item>,
    );
    return {
      breadcrumbItems: breadcrumbItems.filter(Boolean),
      title,
    };
  }, [location.pathname]);

  return (
    <div className="flex flex-col w-full min-h-screen bg-[#FAFAFA]">
      <SEO title={formatMessage({ id: 'seo.menu.title' }, { name: title })} />
      <Header />
      <div className="w-[1366px] mx-auto flex flex-col flex-grow">
        <LayoutContext.Provider value={props}>
          <div className="relative">
            <Breadcrumb
              className="absolute left-0 top-[20px] leading-[17px]"
              separator=">"
            >
              {breadcrumbItems}
            </Breadcrumb>
          </div>
          <div className="pt-[57px] pb-[20px] h-full flex flex-nowrap">
            <div className="basis-[180px] flex-shrink-0">
              <SiderMenu />
            </div>
            <div className="w-[calc(100%_-_196px)] ml-[16px] p-[24px] bg-white">
              <Outlet />
            </div>
          </div>
        </LayoutContext.Provider>
      </div>
      <Footer />
    </div>
  );
};

export default Index;
